import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { Link } from "react-router-dom";
import PageSEO from "@/components/base/PageSEO";

const values = [
  { icon: "ri-heart-3-line", title: "對品質的堅持", desc: "每一件服飾都經過嚴格挑選，從面料、剪裁到縫工，堅持只為您提供真正值得的好衣服。" },
  { icon: "ri-scissors-2-line", title: "修飾版型的美學", desc: "深知女性對版型的在乎，每款設計都注重修身比例，讓不同體型都能穿出最美的樣子。" },
  { icon: "ri-price-tag-3-line", title: "Outlet 的真正意義", desc: "Outlet 不是廉價，而是讓更多女性以合理的價格，入手真正有質感的設計師品牌服飾。" },
  { icon: "ri-user-smile-line", title: "以人為本的服務", desc: "每一位走進門市的女性都是我們最重要的朋友，提供真誠、專業的穿搭建議是我們的初心。" },
];

const milestones = [
  { year: "1994", event: "台灣設計師品牌創立，以都會女性為核心客群，開啟三十年精品旅程。" },
  { year: "2005", event: "品牌系列擴展，引入更多修飾版型設計，廣受熟齡女性好評。" },
  { year: "2015", event: "榮獲多項台灣服飾設計獎項，品牌口碑持續在消費者中傳遞。" },
  { year: "2020", event: "台中 Outlet 門市正式成立，讓更多女性以親切價格入手經典設計師品牌。" },
  { year: "2024", event: "官方網站上線，持續為台中及全台女性提供優雅、質感的穿著選擇。" },
];

export default function About() {
  return (
    <div className="min-h-screen bg-[#faf8f5]">
      <PageSEO
        title="品牌故事｜台中設計師女裝Outlet 30年品牌歷程"
        description="深入了解台中設計師女裝Outlet的品牌故事，30年來堅持為熟齡女性提供高質感修身設計師品牌服飾，讓每位女性都能穿出優雅自信。"
        keywords="台中女裝品牌故事,設計師品牌歷史,熟齡女性時尚,台灣服飾品牌"
        canonical="https://www.example.com/about"
      />
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative h-[60vh] min-h-[420px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=elegant%20taiwanese%20women%20fashion%20brand%20story%20boutique%20interior%20warm%20cream%20rose%20beige%20tones%20designer%20clothing%20display%20graceful%20sophisticated%20atmosphere%20soft%20natural%20light&width=1400&height=700&seq=about001&orientation=landscape"
            alt="品牌故事"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50" />
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
            <p className="text-[#f5d8b8] text-[1rem] tracking-[0.3em] uppercase font-medium mb-3">Our Story</p>
            <h1 className="text-white text-[2.75rem] md:text-[3.25rem] font-bold leading-[1.3] mb-4">品牌故事</h1>
            <p className="text-white/80 text-[1.1875rem] max-w-xl leading-[1.75]">三十年來，我們只做一件事：讓每一位女性都能穿出屬於自己的優雅與自信。</p>
          </div>
        </section>

        {/* Brand Philosophy */}
        <section className="py-20 md:py-28 bg-[#faf8f5]">
          <div className="w-full px-6 md:px-16 max-w-[1400px] mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
              <div>
                <p className="text-[#8B5E52] text-[1rem] tracking-[0.25em] uppercase font-medium mb-3">Brand Philosophy</p>
                <h2 className="text-[#3d2b1f] text-[2.125rem] md:text-[2.5rem] font-bold leading-[1.4] mb-6">品牌理念</h2>
                <p className="text-[#7a6455] text-[1.1875rem] leading-[1.75] mb-5">我們相信，真正的優雅不在於昂貴的標籤，而在於一件能讓你感到自信、舒適的衣服。三十年來，我們選擇與台灣優秀的設計師合作，堅持提供有溫度、有品味的女性服飾。</p>
                <p className="text-[#7a6455] text-[1.1875rem] leading-[1.75] mb-5">我們的 Outlet 門市是一個讓更多女性接觸設計師品牌的橋梁。在這裡，您能以更親切的價格，入手真正值得珍藏的經典設計，感受三十年品牌所累積的美學與工藝。</p>
                <p className="text-[#7a6455] text-[1.1875rem] leading-[1.75]">無論您是尋找職場的俐落感、熟齡的優雅氣質，還是日常的質感休閒風，我們都能為您找到最合適的選擇。這裡不只是購衣的地方，更是發現「更好的自己」的起點。</p>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <img src="https://readdy.ai/api/search-image?query=elegant%20mature%20taiwanese%20woman%20wearing%20designer%20outfit%20graceful%20pose%20cream%20background%20quality%20fabric%20sophisticated%20urban%20style%20fashion%20editorial&width=380&height=480&seq=ab001&orientation=portrait" alt="品牌形象" className="w-full h-full object-cover object-top rounded-lg" />
                <img src="https://readdy.ai/api/search-image?query=elegant%20women%20fashion%20boutique%20clothing%20detail%20fabric%20texture%20warm%20beige%20tones%20taiwanese%20designer%20quality%20craftsmanship%20close%20up&width=380&height=480&seq=ab002&orientation=portrait" alt="品牌質感" className="w-full h-full object-cover object-top rounded-lg mt-8" />
              </div>
            </div>
          </div>
        </section>

        {/* Values */}
        <section className="py-20 md:py-24 bg-[#f5ede4]">
          <div className="w-full px-6 md:px-16 max-w-[1400px] mx-auto">
            <div className="text-center mb-14">
              <p className="text-[#8B5E52] text-[1rem] tracking-[0.25em] uppercase font-medium mb-3">Our Values</p>
              <h2 className="text-[#3d2b1f] text-[2.125rem] md:text-[2.5rem] font-bold leading-[1.4]">我們的核心價值</h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {values.map((v, i) => (
                <div key={i} className="bg-white rounded-lg p-8 flex flex-col items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#f5e8d8]">
                    <i className={`${v.icon} text-[#8B5E52] text-xl`}></i>
                  </div>
                  <h3 className="text-[#3d2b1f] text-[1.25rem] font-bold">{v.title}</h3>
                  <p className="text-[#7a6455] text-[1.0625rem] leading-[1.75]">{v.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Timeline */}
        <section className="py-20 md:py-28 bg-[#faf8f5]">
          <div className="w-full px-6 md:px-16 max-w-[900px] mx-auto">
            <div className="text-center mb-14">
              <p className="text-[#8B5E52] text-[1rem] tracking-[0.25em] uppercase font-medium mb-3">Our Journey</p>
              <h2 className="text-[#3d2b1f] text-[2.125rem] md:text-[2.5rem] font-bold leading-[1.4]">30 年品牌歷程</h2>
            </div>
            <div className="relative flex flex-col gap-0">
              <div className="absolute left-[60px] top-0 bottom-0 w-[2px] bg-[#e8d8c8]" />
              {milestones.map((m, i) => (
                <div key={i} className="relative flex items-start gap-6 pb-10">
                  <div className="relative z-10 flex-shrink-0 w-[120px] text-right">
                    <span className="text-[#8B5E52] text-[1.25rem] font-bold">{m.year}</span>
                  </div>
                  <div className="relative z-10 w-4 h-4 flex-shrink-0 mt-1 rounded-full bg-[#8B5E52] border-4 border-[#faf8f5]" />
                  <p className="text-[#7a6455] text-[1.1875rem] leading-[1.75] pt-0">{m.event}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-16 bg-[#3d2b1f] text-center px-6">
          <h2 className="text-[#f5e8d8] text-[2rem] md:text-[2.5rem] font-bold mb-4">親自來感受品牌溫度</h2>
          <p className="text-[#c9a98a] text-[1.1875rem] mb-8 max-w-lg mx-auto leading-[1.75]">台中實體門市歡迎您到訪，讓我們為您找到最合適的優雅之選。</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/contact" className="px-8 py-3.5 bg-[#c9a98a] text-[#3d2b1f] rounded-full text-[1.0625rem] font-bold hover:bg-[#b8957a] transition-colors cursor-pointer whitespace-nowrap">預約試穿</Link>
            <Link to="/shop" className="px-8 py-3.5 border-2 border-[#c9a98a] text-[#c9a98a] rounded-full text-[1.0625rem] font-semibold hover:bg-[#c9a98a] hover:text-[#3d2b1f] transition-colors cursor-pointer whitespace-nowrap">瀏覽商品</Link>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
